import {
  SET_TOPICS,
  ADD_TOPIC,
  DELETE_TOPIC,
  TOPICS_ERROR,
  SELECT_TOPIC,
  CLEAR_SELECTED,
  UPDATE_TOPIC,
  SET_CUSTOMER_TOPICS,
  APPEND_CUSTOMER_TOPICS,
  REMOVE_CUSTOMER_TOPIC,
  PREPEND_CUSTOMER_TOPICS
} from '../actionTypes';
import ConversationTopicModel from '../components/ConversationTopics/ConversationTopicModel';
import CustomerConversationTopicModel from '../components/ConversationTopics/CustomerConversationTopicModel';

export const setTopics = (topics) => ({ type: SET_TOPICS, payload: topics });
export const addTopic = (topic) => ({ type: ADD_TOPIC, payload: topic });
export const removeTopic = (topicId) => ({ type: DELETE_TOPIC, payload: topicId });
export const topicsError = (message) => ({ type: TOPICS_ERROR, payload: message });
export const selectTopic = (topic) => ({ type: SELECT_TOPIC, payload: topic });
export const clearSelected = () => ({ type: CLEAR_SELECTED });
export const updateTopic = (topic) => ({ type: UPDATE_TOPIC, payload: topic });

export const fetchTopics = () => async (dispatch) => {
  try {
    const data = await ConversationTopicModel.fetchTopics();

    dispatch(setTopics(data));
  } catch (err) {
    dispatch(topicsError(err.message));
  }
};

export const createTopic = (topicFormData) => async (dispatch) => {
  try {
    const topic = await ConversationTopicModel.save(topicFormData);
    dispatch(addTopic(topic));
  } catch (err) {
    dispatch(topicsError(err.message));
    throw err;
  }
};

export const deleteTopic = (topicId) => async (dispatch) => {
  try {
    await ConversationTopicModel.remove({ id: topicId });
    dispatch(removeTopic(topicId));
  } catch (err) {
    dispatch(topicsError(err.message));
    throw err;
  }
};

export const editTopic = (id, body) => async (dispatch) => {
  try {
    const updated = await ConversationTopicModel.editTopic({ id, ...body });
    dispatch(updateTopic(updated));
    dispatch(clearSelected());
  } catch (e) {
    dispatch(topicsError(e.message));
    throw e;
  }
};

export const setCustomerTopics = (payload) => ({
  type: SET_CUSTOMER_TOPICS,
  payload
});

export const appendCustomerTopics = (payload) => ({
  type: APPEND_CUSTOMER_TOPICS,
  payload
});

export const prependCustomerTopic = (topic) => ({
  type: PREPEND_CUSTOMER_TOPICS,
  payload: topic
});

export const removeCustomerTopic = (id) => ({
  type: REMOVE_CUSTOMER_TOPIC,
  payload: id
});

export const fetchCustomerTopics = (customerId, channel, page = 1) => async (dispatch) => {
  try {
    const data = await CustomerConversationTopicModel.fetchCustomerTopics({customerId, channel, page});

    const payload = {
      topics: data.topics,
      hasMore: data.total_pages > page,
      page
    };

    if (page === 1) {
      dispatch(setCustomerTopics(payload));
    } else {
      dispatch(appendCustomerTopics(payload));
    }
  } catch (e) {
    console.error('Error al obtener temas del cliente:', e);
  }
};

export const deleteCustomerTopic = (customerId, topicId) => async (dispatch) => {
  try {
    await CustomerConversationTopicModel.deleteCustomerTopic({ customerId, topicId });
    dispatch(removeCustomerTopic(topicId));
  } catch (e) {
    console.error('Error al eliminar el tema:', e);
    throw e;
  }
};

export const assignCustomerTopic = (customerId, channel, topicableType, topicableId) => async (dispatch) => {
  const body = {
    topicable_type: topicableType,
    topicable_id: topicableId,
    channel
  };

  try {
    const data = await CustomerConversationTopicModel.assignCustomerTopic({ customerId, ...body });
    dispatch(prependCustomerTopic(data));
    return true;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
